// extracted by mini-css-extract-plugin
export default {"canvas":"BabylonCanvas_canvas__vsOWM"};